$(document).ready(function () {

    $(".faq-item .question span").click(function(e) {
        e.preventDefault();
        $(this)
            .parent()
            .parent()
            .toggleClass("open");
    });

    if (document.querySelector('.header-main h1.title')) {
        document.querySelector('.header-main h1.title').classList.add("animated");
    }
    if (document.querySelector('.header-main .subtitle')) {
        document.querySelector('.header-main .subtitle').classList.add("animated");
    }
    if (document.querySelector('.header-main .btn')) {
        document.querySelector('.header-main .btn').classList.add("animated");
    }
    if (document.querySelector('header .header-image')) {
        document.querySelector('header .header-image').classList.add("animated");
    }

    function blocksVisibility() {

        function Check() {

        }

        Check.prototype = {
            constructor: Check,
            isElementInView: function (element, fullyInView) {
                if (!element) return false;
                var pageTop = $(window).scrollTop();
                var pageBottom = pageTop + $(window).height();
                var elementTop = $(element).offset() && $(element).offset().top;
                var elementBottom = elementTop + $(element).height();

                if (fullyInView === true) {
                    return ((pageTop < elementTop) && (pageBottom > elementBottom));
                } else {
                    return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
                }
            }
        };

        var Check = new Check();

        function doAnimate(elem) {

            var isElementInView = Check.isElementInView(elem, false);
            if (isElementInView) {
                if ( !elem.hasClass('animated') ) {
                    elem.addClass('animated');
                }
            }
        }

        const animateBloks = [$('.characteristics'), $('.app'), $('.faq'), $('.terms'), $('main > .button-wrapper').eq(0), $('.vue-form') , $('.filling'), $(".tariffs"), $('main > .button-wrapper').eq(1)];
        animateBloks.forEach(function(block) {
            doAnimate(block);
        });
    }
    window.addEventListener('scroll', blocksVisibility, {passive: true} );
    blocksVisibility();


    $('.scrollToForm').on("click",  function(){
        let el = document.querySelector('.vue-form');
        $('html, body').animate({scrollTop: $(el).position().top}, 1000);

    });

});



// WEBPACK FOOTER //
// ./src/credit-landing/cash.js